import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Toast from '../commons/helpers/toast';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import { clearAction, changePasswordAction } from '../../actions/commonActions'; 
import { logoutUserAction } from '../../actions/authenticationActions';
import validator from 'validator';

import {formValid} from '../../utils/validation';

import { getStorage } from '../../utils/browserStorage';

import { LBL_APP_NAME, LBL_SETTINGS } from '../../configs/labelConfigs';
import { MSG_VALIDATION_ERROR_1,MSG_VALIDATION_ERROR_2,MSG_VALIDATION_ERROR_3,MSG_VALIDATION_ERROR_4,MSG_PASSWORD_MISMATCH, MSG_CURR_PASSWORD_REQUIRED, MSG_NEW_PASSWORD_REQUIRED,MSG_NEW_PWDCONFIRM_REQUIRED, MSG_CURR_NEW_PWD_SAME, MSG_CHANGE_PASSWORD_SUCCESS, MSG_CHANGE_PASSWORD_ERROR } from '../../configs/msgConfigs';
import * as staticConfigs from '../../configs/staticConfigs'; 

import { CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_ERROR } from '../../actions';

class ChangePasswordComponent extends Component { 

    constructor(props){
        super(props)

        this.state = {
            formErrors : {}, 
            currentPassword: '', 
            newPassword: '',
            confirnNewPassword: '',
            userId:0,            
            formError_currPwd: MSG_CURR_PASSWORD_REQUIRED,
            formError_newPwd: MSG_VALIDATION_ERROR_1, 
            formError_confirmPwd: MSG_NEW_PWDCONFIRM_REQUIRED, 
            formError_commonErr: '',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true  
        }
        this.checkFormData = this.checkFormData.bind(this); 
    }

    onLogout = () =>{
        let userGroupData = userGroupUrlCheck(this.props.location);
        let username      = '';
        let unid          = '';
        let fcmToken = getStorage('fcmNotificationToken');
        if(userGroupData!==undefined){
            username      = userGroupData.username;
            unid          = userGroupData.unid;
        }
       
        this.props.logoutUserAction({username: username,unid:unid,fcm_token:fcmToken,device_type:1});
    }

    componentDidMount() { 
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup    = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }  
        document.title = LBL_APP_NAME+' - Change Password'; // ' - '+LBL_SETTINGS+
    }
    validate = (value) => {
  
        if (validator.isStrongPassword(value, {
          minLength: 8, minLowercase: 1,
          minUppercase: 1, minNumbers: 1, minSymbols: 1
        })) {
          return true
        } else {
          return false
        }
    }   

    onHandleChange = (event) =>{         
        const {name, value} = event.target;
        let formErr = '';
        let txtVal  = value.trim();
        let validated = true;
        if(name === 'txt_newPwd'){
            validated = this.validate(value);
        }
        

        switch(name){
            case 'txt_currPwd':
                formErr = txtVal.length <=0 ? MSG_CURR_PASSWORD_REQUIRED : ""; 
                this.setState({currentPassword:txtVal, formError_currPwd:formErr}); 
                break;       
            case 'txt_newPwd':
                formErr = txtVal.length <=0 ? MSG_NEW_PASSWORD_REQUIRED : validated?"":MSG_VALIDATION_ERROR_1; 
                this.setState({newPassword:txtVal, formError_newPwd:formErr, formError_commonErr:''}); 
                break;      
            case 'txt_confirmNewPwd':
                formErr = txtVal.length <=0 ? MSG_NEW_PWDCONFIRM_REQUIRED : ""; 
                this.setState({confirnNewPassword:txtVal, formError_confirmPwd:formErr, formError_commonErr:''}); 
                break;                                
            default : break;
        }
    } 

    checkFormData() {
        if(this.state.currentPassword.trim()==='') {
            this.setState({formError_currPwd:MSG_CURR_PASSWORD_REQUIRED});  
            return false; 
        }
        else if(this.state.newPassword.trim()==='' || !this.validate(this.state.newPassword)) {
            this.setState({formError_newPwd:MSG_NEW_PASSWORD_REQUIRED});  
            return false; 
        }
        else if(this.state.confirnNewPassword.trim()==='') {
            this.setState({formError_confirmPwd:MSG_NEW_PWDCONFIRM_REQUIRED});  
            return false; 
        }
        else if(this.state.currentPassword===this.state.newPassword) {
            this.setState({formError_commonErr:MSG_CURR_NEW_PWD_SAME});  
            return false; 
        }
        else if(this.state.newPassword!==this.state.confirnNewPassword) {
            this.setState({formError_commonErr:MSG_PASSWORD_MISMATCH});  
            return false; 
        }
        else {
            return true; 
        }
    }

    saveFormData = () =>{
        if(formValid(this.state)){
            if(this.checkFormData()) { 
                let tmpData = {
                    new_password: this.state.newPassword,
                    old_password: this.state.currentPassword 
                } 
                this.props.changePasswordAction(tmpData);
                setTimeout(()=> {
                    this.onCloseToast();
                }, 3000);
            }
        }else{
            // let formErrors = this.state.formErrors;
            // if(this.state.sectorData.sectorName==null){
            //     formErrors.sectorName = MSG_SECTOR_REQUIRED;
            // }            
            // this.setState({formErrors});
        }
    }

    onCloseToast = () =>{
        this.setState({toastSuccess:true,toastFlag:false,toastMessage:''});
    } 

    componentDidUpdate(prevProps) { 
        const { status, activity } = this.props;
        if(status===401 || status===403){
            return <Redirect to={staticConfigs.ROUTE_REFRESH} />;
        }
        if (activity && (activity !== prevProps.activity || status !== prevProps.status)) {
            var arrResp = activity.split('~~'); 
            var actString = arrResp[0]; 
            if(actString===CHANGE_PASSWORD_SUCCESS){ 
                this.setState({toastSuccess:true,toastFlag:true,toastMessage:MSG_CHANGE_PASSWORD_SUCCESS, currentPassword: '',  newPassword: '', confirnNewPassword: '', formError_currPwd: '', formError_newPwd: '', formError_confirmPwd: '' }); 
                setTimeout(()=> {
                    this.onCloseToast();

                   
                
                        let userGroupData = userGroupUrlCheck(this.props.location);
                        let userGroup  = '';
                    
                        if(userGroupData!==undefined){
                            userGroup  = userGroupData.user_group;
                        }
        
                        let loginRoute = '';
                        let dashboardRoute = '';
                        if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
                            loginRoute = staticConfigs.LOGIN_ROUTE_SUPER_ADMIN;
                            dashboardRoute = staticConfigs.ROUTE_DASHBOARD;
                        }else if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
                            loginRoute = staticConfigs.LOGIN_ROUTE_AFFILIATE;
                            dashboardRoute = staticConfigs.ROUTE_AFFILIATE_DASHBOARD;
                        }else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
                            loginRoute = staticConfigs.LOGIN_ROUTE_CLIENT;
                            dashboardRoute = staticConfigs.ROUTE_CLIENT_DASHBOARD;
                        }
        
                        if(status){
        
                            if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
                                document.body.classList.remove('body-affiliate'); 
                            }
        
                            if(this.props.location.pathname.includes(staticConfigs.LOGIN_ROUTE_SUPER_ADMIN)){
                                localStorage.removeItem("super");
                            }else if(this.props.location.pathname.includes(staticConfigs.LOGIN_ROUTE_AFFILIATE)){
                                localStorage.removeItem("affiliate");
                            }else if(this.props.location.pathname.includes(staticConfigs.LOGIN_ROUTE_CLIENT)){
                                localStorage.removeItem("client");
                            }else{
                                localStorage.clear();
                            }                
                            this.props.history.push(loginRoute);
                        }else{
                            this.props.history.push(dashboardRoute)
                        }
               
                    this.props.clearAction();

                }, 2500); 
            } else if(actString===CHANGE_PASSWORD_ERROR){
                let errMsg = (this.props.hasOwnProperty('responseData')  && this.props.responseData.hasOwnProperty('message')) ? this.props.responseData.message : MSG_CHANGE_PASSWORD_ERROR; 
                this.setState({toastSuccess:false,toastFlag:true,toastMessage:errMsg});
                setTimeout(()=> {
                    this.onCloseToast();
                }, 6000);
            }
        }
    }


    render(){
        const { toastMessage,toastFlag,toastSuccess,formError_currPwd,formError_newPwd,formError_confirmPwd} = this.state; 

        const { location,status } = this.props; 

        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        if(status===401 || status===403){
            if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
                return <Redirect to={staticConfigs.ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={staticConfigs.ROUTE_REFRESH} />;

            }
        }

        if (location.pathname===staticConfigs.ROUTE_RESET_PASSWORD) 
        return (
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="tab-head">
                        <h6>Reset Password</h6>
                    </div>
                    <div className="box-content">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>New Password</label>
                                    <div className="text-input"><input type="text" /></div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Re-Enter New Password</label>
                                    <div className="text-input"><input type="text" /></div>
                                </div>
                            </div>                              
                        </div>
                        <div className="clearfix">
                            <button className="btn btn-primary float-right">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        )
        else return(
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="tab-head">
                        <h6>Change Password</h6>
                    </div>
                    <div className="box-content">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Current Password</label>
                                    <div className="text-input"><input type="password" placeholder="" name="txt_currPwd" value={this.state.currentPassword} onChange={this.onHandleChange} maxLength = {120} className={formError_currPwd.length >0 ?"input-error":''} /></div>
                                    {/* {this.state.formError_currPwd.length >0 && (
                                        <div className="text-red left-align text-12">{this.state.formError_currPwd}</div>
                                        )}  */}
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                            
                        </div> 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>New Password</label>
                                    <div className="text-input"><input type="password" placeholder="" name="txt_newPwd" value={this.state.newPassword} onChange={this.onHandleChange} maxLength = {120} className={formError_newPwd.length >0 ?"input-error":''} /></div>
                                    {this.state.formError_newPwd.length >0 && (
                                        <div className="text-red left-align text-12 display-grid">
                                            <span>{MSG_VALIDATION_ERROR_1}</span>
                                            <span>{MSG_VALIDATION_ERROR_2}</span>
                                            <span>{MSG_VALIDATION_ERROR_3}</span>
                                            <span>{MSG_VALIDATION_ERROR_4}</span>
                                        </div>
                                        )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Re-Enter New Password</label>
                                    <div className="text-input"><input type="password" placeholder="" name="txt_confirmNewPwd" value={this.state.confirnNewPassword} onChange={this.onHandleChange} maxLength = {120} className={formError_confirmPwd.length >0 ?"input-error":''} /></div>
                                    {this.state.formError_commonErr.length >0 && (
                                        <div className="text-red left-align text-12">{this.state.formError_commonErr}</div>
                                        )} 
                                </div>
                            </div>                              
                        </div>
                        <div className="clearfix">
                            <button className="btn btn-primary float-right"  onClick={this.saveFormData}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status:state.changePassword.status,
        activity:state.changePassword.activity,
        responseData:state.changePassword.responseData,
        errorData: state.changePassword.errorData,
    }
}           

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        changePasswordAction:changePasswordAction,  
        logoutUserAction:logoutUserAction,
        clearAction:clearAction
    },dispatch);
} 
export default connect(mapStateToProps,mapDispatchToProps)(ChangePasswordComponent);